// Level hesaplama
// İlk level'ler hızlı — motivasyon için
// Lv1→2: 15, Lv2→3: 30, Lv3→4: 50, sonra 50*level, Lv11+: 500
const EARLY_LEVELS = [10, 40, 50];

function xpForLevel(level: number): number {
  if (level <= 1) return EARLY_LEVELS[0];        // 15 XP for Lv2
  if (level <= EARLY_LEVELS.length) return EARLY_LEVELS[level - 1];
  return level <= 10 ? 50 * level : 500;
}

export function getLevelFromXp(xp: number): {
  level: number;
  progress: number;
  xpToNextLevel: number;
  currentLevelXp: number;
  totalForNextLevel: number;
} {
  let level = 1;
  let totalRequired = 0;
  let nextRequired = xpForLevel(level);

  while (xp >= totalRequired + nextRequired) {
    totalRequired += nextRequired;
    level++;
    nextRequired = xpForLevel(level);
  }

  const currentLevelXp = xp - totalRequired;
  return {
    level,
    progress: Math.round((currentLevelXp / nextRequired) * 100),
    xpToNextLevel: nextRequired - currentLevelXp,
    currentLevelXp,
    totalForNextLevel: nextRequired,
  };
}

// Motivasyon mesajları
const CORRECT_MESSAGES = [
  "Harika! Devam et!",
  "Muhteşem çözüm!",
  "Tam isabet!",
  "Süpersin!",
  "Mükemmel iş!",
  "Kod yazma becerilerin gelişiyor!",
  "Böyle devam!",
  "Tebrikler, doğru cevap!",
  "Her gün biraz daha iyi!",
  "Pes etmedin ve başardın!",
];

const WRONG_MESSAGES = [
  "Denemek önemli, bir daha dene!",
  "Yanlış cevap ama XP kazandın!",
  "Öğrenme sürecinin bir parçası!",
  "Tekrar deneyerek gelişirsin!",
];

const STREAK_MILESTONES: Record<number, string> = {
  3: "3 gün üst üste! Harika başlangıç! 🔥",
  5: "5 günlük seri! Muhteşem! 🔥🔥",
  7: "Tam bir hafta! İnanılmaz! 🔥🔥🔥",
  10: "10 gün! Durdurulamıyorsun!",
  14: "2 haftalık seri! Efsanevi!",
  21: "3 hafta! Gerçek bir savaşçısın!",
  30: "30 gün! Kodu fethetttin!",
};

export function getRandomMessage(isCorrect: boolean): string {
  const arr = isCorrect ? CORRECT_MESSAGES : WRONG_MESSAGES;
  return arr[Math.floor(Math.random() * arr.length)];
}

export function getStreakMilestoneMessage(streak: number): string | null {
  return STREAK_MILESTONES[streak] || null;
}

// Confetti renkleri
export const CONFETTI_COLORS = ["#71D000", "#0066C8", "#FF6B35", "#ffffff"];
